import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-who-we-are',
    templateUrl: './who-we-are.component.html'
})
export class WhoWeAreComponent implements OnInit {

    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Kik vagyunk?'});
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/who-we-are.component.ts